import axios from 'axios'
import { generateResponse, generateErrorResponse } from './common'

const API_END_POINT = process.env.API_END_POINT
const CHECK_AUTH = API_END_POINT + '/auth/touch'
const LOGIN_URL = API_END_POINT + '/auth/login'
const REGISTER_URL = API_END_POINT + '/auth/register'
const COMPANY_REGISTER_URL = REGISTER_URL + '/manipulator'
const FORGOT_PASSWORD = API_END_POINT + '/auth/forgotpassword'
const MANIPULATOR_FORGOT_PASSWORD = FORGOT_PASSWORD + '/manipulator'
const RESET_PASSWORD = API_END_POINT + '/auth/resetpassword'
const ACTIVE_ACCOUNT = API_END_POINT + '/auth/activeaccount'

export default {
  API_END_POINT: API_END_POINT,
  touch (token) {
    return axios({
      url: CHECK_AUTH,
      method: 'get',
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  resetPassword (creds) {
    return axios({
      url: RESET_PASSWORD,
      method: 'post',
      data: creds
    }).then(generateResponse, generateErrorResponse)
  },
  forgotPasswordCheckToken (token) {
    return axios({
      url: FORGOT_PASSWORD + '?token=' + token,
      method: 'get'
    }).then(generateResponse, generateErrorResponse)
  },
  manipulatorForgotPassword (creds) {
    return axios({
      url: MANIPULATOR_FORGOT_PASSWORD,
      method: 'post',
      data: creds
    }).then(generateResponse, generateErrorResponse)
  },
  forgotPassword (creds) {
    return axios({
      url: FORGOT_PASSWORD,
      method: 'post',
      data: creds
    }).then(generateResponse, generateErrorResponse)
  },
  companyRegister (creds) {
    return axios({
      url: COMPANY_REGISTER_URL,
      method: 'post',
      data: creds
    }).then(generateResponse, generateErrorResponse)
  },
  companyLogin (creds) {
    const data = Object.assign({}, creds, {
      manipulator: true
    })
    return axios({
      url: LOGIN_URL,
      method: 'post',
      data: data
    }).then(generateResponse, generateErrorResponse)
  },
  register (creds) {
    return axios({
      url: REGISTER_URL,
      method: 'post',
      data: creds
    }).then(generateResponse, generateErrorResponse)
  },
  activeUserAccount (creds) {
    return axios({
      url: ACTIVE_ACCOUNT,
      method: 'post',
      data: {
        id: creds.id,
        checkSum: creds.checkSum
      }
    }).then(generateResponse, generateErrorResponse)
  },
  login (creds) {
    return axios({
      url: LOGIN_URL,
      method: 'post',
      data: creds
    }).then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js